import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Menu, MenuItem } from 'semantic-ui-react'
import styled from 'styled-components'
import { useTabletAndBelowMediaQuery } from 'layout'
import { useQueryString } from 'hooks'

import { InvoiceScreen } from './invoice'
import { InvoicePrefixScreen } from './InvoicePrefix'
import InvoiceRules from './InvoiceRules'

const InvoiceSettingContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    .invoice-menu {
        width: 100% !important;
        overflow-x: auto;
        ::-webkit-scrollbar {
            height: 5px;
        }
        .active {
            background: ${({ theme }) => theme.colors.body} !important;
        }
    }
`

const MenuList = ({ list, activeTab, onTabChange, isMobile }) => (
    <Menu vertical={!isMobile} className="invoice-menu">
        {list.map(ele => (
            <MenuItem
                key={ele.key}
                active={activeTab === ele.key}
                onClick={() => onTabChange(ele.key)}
            >
                {ele.title}
            </MenuItem>
        ))}
    </Menu>
)

export const InvoiceSettingsScreen = () => {
    const isMobile = useTabletAndBelowMediaQuery()
    const navigate = useNavigate()
    const query = useQueryString()
    const invoiceTab = query.get('invoiceTab')

    const subTabs = [
        { key: 'invoice', title: 'Invoice' },
        { key: 'prefix', title: 'Invoice Prefix' },
        { key: 'rules', title: 'Invoice Rules' },
    ]

    const [activeTab, setActiveTab] = useState('invoice')

    useEffect(() => {
        if (invoiceTab && subTabs.some(tab => tab.key === invoiceTab)) {
            setActiveTab(invoiceTab)
        } else {
            setActiveTab('invoice')
        }
    }, [invoiceTab])

    const handleTabChange = (key) => {
        navigate(`?invoiceTab=${key}`)
    }

    return (
        <InvoiceSettingContainer
            className={`col-12 ${isMobile ? 'flex-column' : 'flex-row'
                }`}
        >
            <div className={`${isMobile ? 'col-12' : 'col-3'}`}>
                <MenuList
                    isMobile={isMobile}
                    list={subTabs}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                />
            </div>
            <div className="col mt-0 px-0">
                {activeTab === 'invoice' && <InvoiceScreen />}
                {activeTab === 'prefix' && <InvoicePrefixScreen />}
                {activeTab === 'rules' && <InvoiceRules />}
            </div>
        </InvoiceSettingContainer>
    )
}
